import React from "react";
import { useTranslation, Trans } from "react-i18next";

import {
  Modal,
  Image,
  Button,
  Card,
  Divider,
  Row,
  Col
} from '@lockerpm/design';

import CheckCircleImg from '../../../../../assets/images/icons/check-circle.svg';

import global from "../../../../../config/global";
import common from "../../../../../utils/common";

const PayResultModal = (props) => {
  const { t } = useTranslation();

  const {
    visible = false,
    result = {},
    discountPercentage = 0,
    nextBill = '',
    selectedCard = {},
    selectedPlan = {},
    selectedPeriod = {},
  } = props;

  return (
    <Modal
      open={visible}
      style={{
        top: 60
      }}
      onCancel={() => {}}
      width={740}
      footer={false}
      closeIcon={<></>}
    >
      <div className="text-center">
        <Image
          src={CheckCircleImg}
          preview={false}
        />
        <h1 className="text-black font-semibold text-head-4 mt-2">
          {t('billing.payment_success')}
        </h1>
        <p className="mt-2">
          <Trans
            i18nKey={'billing.thank_you'}
            components={{
              br: <br />
            }}
          />
        </p>
        <Button
          className="mt-4"
          type="primary"
          onClick={() => global.navigate(global.keys.VAULT)}
        >
          {t('billing.back_to_home')}
        </Button>
      </div>
      <Card
        size="small"
        className="mt-4"
        title={
          <p className="text-[16px] font-semibold">
            {t('manage_plans.order_summary')}
          </p>
        }
      >
        <div>
          <div className="flex justify-between">
            <div className="pr-3">
              <p className="text-black-600">
                <span className="font-semibold text-[16px]">{selectedPlan.name}</span>
                <br />
                {t(selectedPeriod.label)}
              </p>
            </div>
            <p className="font-semibold text-[16px]">
              {common.formatCurrency(result.price, 2, result.currency)}
            </p>
          </div>
          {
            result.discount !== 0 && <div
              className="text-warning mt-2 flex justify-between"
            >
              <p>{t('common.discount')} -{discountPercentage}%</p>
              <p>
                -{common.formatCurrency(result.discount, 2, result.currency)}
              </p>
            </div>
          }
        </div>
        <Divider className="my-2"/>
        <div className="flex justify-between">
          <div>
            <p className="text-black-600 font-semibold text-[16px] pr-3">
              {t('common.total')}
            </p>
            <p className="text-black-600">
              {t('manage_plans.next_billing_on')} {nextBill}
            </p>
          </div>
          <p className="font-semibold text-[16px]">
            {common.formatCurrency(result.immediate_payment, 2, result.currency)}
          </p>
        </div>
      </Card>
      {
        selectedCard.metadata && <Card
          size="small"
          className="mt-4"
          title={
            <p className="text-[16px] font-semibold">
              {t('billing.billing_contact')}
            </p>
          }
        >
          <Row gutter={[12, 12]}>
            <Col xl={12} lg={12} span={24}>
              <div className="">
                <p className="font-semibold">{t('common.name')}</p>
                <p className="text-black-600">{selectedCard.metadata.contact_name}</p>
              </div>
            </Col>
            <Col xl={12} lg={12} span={24}>
              <div>
                <p className="font-semibold">{t('common.email')}</p>
                <p className="text-black-600">{selectedCard.metadata.email}</p>
              </div>
            </Col>
          </Row>
          {
            selectedCard.metadata.company && <div className="mt-3">
              <p className="font-semibold">{t('common.company')}</p>
              <p className="text-black-600">{selectedCard.metadata.company}</p>
            </div>
          }
        </Card>
      }
      <Card
        size="small"
        className="mt-4"
        title={
          <p className="text-[16px] font-semibold">
            {t('billing.billing_address')}
          </p>
        }
      >
        <div className="mb-3">
          <p className="font-semibold">{t('common.address')}</p>
          <p className="text-black-600">{selectedCard.address}</p>
        </div>
        <Row gutter={[12, 12]}>
          <Col xl={12} lg={12} span={24}>
            <div className="">
              <p className="font-semibold">{t('common.city')}</p>
              <p className="text-black-600">{selectedCard.address_city}</p>
            </div>
          </Col>
          <Col xl={12} lg={12} span={24}>
            <div>
              <p className="font-semibold">{t('common.country')}</p>
              <p className="text-black-600">{selectedCard.address_country}</p>
            </div>
          </Col>
          {
            selectedCard.address_state && <Col xl={12} lg={12} span={24}>
              <div className="">
                <p className="font-semibold">{t('common.state')}</p>
                <p className="text-black-600">{selectedCard.address_state}</p>
              </div>
            </Col>
          }
          {
            selectedCard.address_zip && <Col xl={12} lg={12} span={24}>
              <div>
                <p className="font-semibold">{t('common.zip')}</p>
                <p className="text-black-600">{selectedCard.address_zip}</p>
              </div>
            </Col>
          }
        </Row>
      </Card>
    </Modal>
  );
}

export default PayResultModal;